import { render, staticRenderFns } from "./FormCreateEdit.vue?vue&type=template&id=e78310f2"
import script from "./FormCreateEdit.vue?vue&type=script&lang=js"
export * from "./FormCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports